const unsafeKeys = new Set(['constructor', '__proto__', 'prototype']);
export function isSafeKey(key) {
    return !unsafeKeys.has(key);
}
//# sourceMappingURL=objects.js.map